import { PageHeader, cn } from '@sitewise/ui';
import { useQuery } from '@tanstack/react-query';
import { NavLink, Outlet } from 'react-router-dom';

import { fetchMe } from '../../../api/auth.js';

interface TabItem {
  to: string;
  label: string;
  adminOnly?: boolean;
}

const TABS: TabItem[] = [
  { to: '/compliance', label: 'Dashboard' },
  { to: '/compliance/records', label: 'Records' },
  { to: '/compliance/devices', label: 'Devices' },
  { to: '/compliance/upload', label: 'Upload' },
  { to: '/compliance/device-types', label: 'Device types', adminOnly: true },
  { to: '/lead', label: 'Lead' },
];

export function ComplianceLayout() {
  const meQuery = useQuery({ queryKey: ['me'], queryFn: fetchMe });
  const isAdmin = meQuery.data?.user.role === 'admin';
  const visible = TABS.filter((t) => !t.adminOnly || isAdmin);

  return (
    <>
      <PageHeader
        title="Compliance"
        description="Track required inspections, file logs, and let SiteWise open work orders when items go overdue."
      />
      <nav className="mb-4 border-b border-border">
        <ul className="flex gap-1 -mb-px">
          {visible.map((tab) => (
            <li key={tab.to}>
              <NavLink
                to={tab.to}
                end={tab.to === '/compliance'}
                className={({ isActive }) =>
                  cn(
                    'inline-block border-b-2 px-3 py-2 text-sm font-medium transition-colors',
                    isActive
                      ? 'border-primary text-primary'
                      : 'border-transparent text-fg-secondary hover:text-fg',
                  )
                }
              >
                {tab.label}
              </NavLink>
            </li>
          ))}
        </ul>
      </nav>
      <Outlet />
    </>
  );
}
